var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.739 127.877L43.6064 144.689C34.4998 146.446 25.6655 140.58 23.7516 131.505L5.83722 46.5637L5.72461 46.0766C3.60997 36.929 9.31133 27.7991 18.4589 25.6845L103.224 6.08963C112.371 3.975 121.501 9.67635 123.616 18.824L143.548 105.05L144.081 107.356C146.251 116.741 140.197 126.052 130.739 127.877Z",
    stroke: "#E2413B",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackimg);
export default __webpack_public_path__ + "static/media/backimg.27723166e0b931408c983f0e6227b22d.svg";
export { ForwardRef as ReactComponent };